/** @jsx jsx */
import { jsx } from '@emotion/react';
import { UNSAFE_Text as Text } from '@atlaskit/ds-explorations';
import FocusRing from '@atlaskit/focus-ring';
import { useTab } from '../hooks';
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */
export default function Tab(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  var _useTab = useTab(),
    onClick = _useTab.onClick,
    id = _useTab.id,
    ariaControls = _useTab['aria-controls'],
    ariaPosinset = _useTab['aria-posinset'],
    ariaSelected = _useTab['aria-selected'],
    ariaSetsize = _useTab['aria-setsize'],
    onMouseDown = _useTab.onMouseDown,
    onKeyDown = _useTab.onKeyDown,
    role = _useTab.role,
    tabIndex = _useTab.tabIndex;
  return jsx(FocusRing, {
    isInset: true
  }, jsx("div", {
    "data-testid": testId,
    onClick: onClick,
    id: id,
    "aria-controls": ariaControls,
    "aria-posinset": ariaPosinset,
    "aria-selected": ariaSelected,
    "aria-setsize": ariaSetsize,
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    role: role,
    tabIndex: tabIndex
  }, jsx(Text, {
    shouldTruncate: true,
    UNSAFE_style: {
      color: 'inherit'
    }
  }, children)));
}